module.exports = __webpack_public_path__ + "static/img/logo_limpio.5d7465f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_limpio.png
// module id = UR66
// module chunks = 0